export enum PaymentTypeEnum {
	PAYMENT_EXP = 'payment-exp',
	PAYMENT_PCR = 'payment-pcr',
	PAYMENT_DGOS = 'payment-dgos'
}
